import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { render, NODE_PARAGRAPH, MARK_LINK } from 'storyblok-rich-text-react-renderer';
import clsx from 'clsx';
import LATORI_BG_COLORS from './constants';
import LinkResolver from '../../helpers/link-resolver';

export default function BlogPostHighlightBox(blok) {
  const { bg_color: bgColor, text } = blok;

  const styles = clsx(
    'blok-blogpost-highlight-box my-5 p-7 text-white',
    LATORI_BG_COLORS[bgColor || 'latori-color-green-dark'],
  );

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      {render(text, {
        markResolvers: {
          [MARK_LINK]: LinkResolver,
        },
        nodeResolvers: {
          // eslint-disable-next-line react/no-unstable-nested-components
          [NODE_PARAGRAPH]: (children) => (
            <p className="first-of-type:mt-0 last-of-type:mb-0">{children}</p>
          ),
        },
      })}
    </div>
  );
}
